import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'passwordReset';

export const requestReset = createAction(`${ACTION_PREFIX}/REQUEST_RESET`);
export const requestResetSucceeded = createAction(`${ACTION_PREFIX}/REQUEST_RESET_SUCCEEDED`);
export const requestResetFailed = createAction(`${ACTION_PREFIX}/REQUEST_RESET_FAILED`);

export const PasswordResetActions = {
  requestReset,
  requestResetSucceeded,
  requestResetFailed,
};
